export default __webpack_public_path__ + "static/media/070_boost.first.5a3c6559.avif";